function changeViewGrid(event) {
  const productGrid = document.querySelector("#product-grid");
  const ieBookLink = document.querySelector("#ie-book-link");
  const btnGridView = document.querySelector("button.grid-view");
  const btnListView = document.querySelector("button.list-view");
    productGrid.classList.remove('list-view')
    productGrid.classList.add('grid-view')
    btnGridView.classList.add('view-active')
    btnListView.classList.remove('view-active')
    setView('grid-view');
    ieBookLink.classList.remove('!tw-hidden')
}

function changeViewList(event) {
  const productGrid = document.querySelector("#product-grid");
  const ieBookLink = document.querySelector("#ie-book-link");
  const btnGridView = document.querySelector("button.grid-view");
  const btnListView = document.querySelector("button.list-view");
  productGrid.classList.remove('grid-view')
  productGrid.classList.add('list-view')
  btnGridView.classList.remove('view-active')
  btnListView.classList.add('view-active')
  setView('list-view');
  ieBookLink.classList.add('!tw-hidden')
}

function setView(view) {
  localStorage.setItem('view', view);
}

function getView(view) {
  return localStorage.getItem('view');
}

var viewSelected = localStorage.getItem('view');

function viewLocal(event){
  const productGrid = document.querySelector("#product-grid");
  const ieBookLink = document.querySelector("#ie-book-link");
  const btnGridView = document.querySelector("button.grid-view");
  const btnListView = document.querySelector("button.list-view");

  if (viewSelected == 'list-view') {
    productGrid.classList.remove('grid-view')
    productGrid.classList.add('list-view')
    if (btnGridView) {
      btnGridView.classList.remove('view-active')
    }
    if (btnListView) {
      btnListView.classList.add('view-active')
    }
    if (ieBookLink) {
      ieBookLink.classList.add('!tw-hidden')
    }
    } else {
      productGrid.classList.remove('list-view')
      productGrid.classList.add('grid-view')
      if (btnGridView) {
        btnGridView.classList.add('view-active')
      }
      if (btnListView) {
        btnListView.classList.remove('view-active')
      }
      if (ieBookLink) {
        ieBookLink.classList.remove('!tw-hidden')
      }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    viewLocal();
});


